import { render, staticRenderFns } from "./BidsEmpty.vue?vue&type=template&id=f6bf8e18"
import script from "./BidsEmpty.vue?vue&type=script&lang=js"
export * from "./BidsEmpty.vue?vue&type=script&lang=js"
import style0 from "./BidsEmpty.vue?vue&type=style&index=0&id=f6bf8e18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports